/**
 * User class
 * 
 * @class User
 * @singleton
 * @mixins Events
 */

User = (function(Events) {

	var User = {};
	
	$.extend(true, User, Events, {
		init: function(){
			this.userName = '';   // {String} login name 
			this.logged = false;     // {Boolean} login state
		},
		
		isLogged: function() {
			return this.logged;
		},
		
		getUserName: function() {
			return this.userName || Storage.get('userName');
		},
		
		getUserId: function() {
			return this.id || Storage.get('userId');
		},

		/**
		 * Sign in (login)
		 * @param {String} loginName - login name (typically some email)
		 */
		signIn: function(email, userid, username) {
			Storage.set('email', email);			
			Storage.set('userId', userid || '');
			Storage.set('userName', username || '');
			this.logged = true;
		},

		signOut: function() {
            Storage.set('email', '');
			Storage.set('userId', '');			
			Storage.set('userName', '');			
			this.logged = false;
		},

		/**
		 * Get Language of Application
		 * @returns {String} language
		 */
		getAppLang: function() {
			return Storage.get('appLanguage');
		},
		
		/**
		 * Set Language of Application
		 * @param {String} language - language as ISO-639-1 code (e.g. 'en') 
		 */
		setAppLang: function(language) {
			return Storage.set('appLanguage', language);
		},

	});

	User.init();
	
	return User;
})(Events);


//////////////////
// WEBPACK FOOTER
// ./js/module/user.js
// module id = 51
// module chunks = 0